// extracted by mini-css-extract-plugin
export default {"accept-drop":"_2G7dE","acceptDrop":"_2G7dE","reject-drop":"qTuU4","rejectDrop":"qTuU4"};